import Athieno from "../../assets/images/creators/Creator 12 - @Athieno.png";
import Alyttleton from "../../assets/images/creators/Creator 13 - @Alyttleton.png";
import MacieJay from "../../assets/images/creators/Creator 14 - @MacieJay.png";
import KingGeorge from "../../assets/images/creators/Creator 15 - @KingGeorge.png";
import FastAnne from "../../assets/images/creators/Creator 16 - @FastAnne.png";
import LusorKoeffizient from "../../assets/images/creators/Creator 17 - @LusorKoeffizient.png";
import RoyzaGaming from "../../assets/images/creators/Creator 18 - @RoyzaGaming.png";
import NarcolepticNugget from "../../assets/images/creators/Creator 19 - @NarcolepticNugget.png";
import TomJSherlock from "../../assets/images/creators/Creator 20 - @TomJSherlock.png";
import TitaniumRolo from "../../assets/images/creators/Creator 21 - @TitaniumRolo.png";

import { Creator } from "./types";

export const CREATORS: Creator[] = [
  {
    name: "@Athieno",
    src: Athieno,
    link: "https://www.youtube.com/@AthienoR6",
    quote: "UCP is where streamers can ramp up their content game",
  },
  {
    name: "@Alyttleton",
    src: Alyttleton,
    link: "https://www.youtube.com/@alyttleton",
    quote:
      "I really like the 'Ongoing campaigns' dashboard which make sit incredibly easy to manage and organise ongoing and upcoming campaigns'",
  },
  {
    name: "@MacieJay",
    src: MacieJay,
    link: "https://www.youtube.com/MacieJay",
    quote: "Super convenient way to get the content to make the content.",
  },
  {
    name: "@KingGeorge",
    src: KingGeorge,
    link: "https://twitch.tv/KingGeorge",
    quote:
      "The Ubisoft Creators Program gives me awesome in game content, and early access to my favorite games + new updates.",
  },
  {
    name: "@FastAnne",
    src: FastAnne,
    link: "https://www.twitch.tv/fastanne",
    quote:
      "The Ubisoft Creator Program gives me amazing opportunities like drops on my stream to grow my audience and to do something back for the viewers",
  },
  {
    name: "@LusorKoeffizient",
    src: LusorKoeffizient,
    link: "https://www.youtube.com/@lusorkoeffizient",
    quote:
      'The Ubisoft creator program allows me to easily bring exclusive content and campaigns to my community."\n\n"The great thing about the Creator Program is that I have a direct line to Ubisoft and can offer our viewers cool and exclusive content.',
  },
  {
    name: "@RoyzaGaming",
    src: RoyzaGaming,
    link: "https://www.twitch.tv/royzagaming/",
    quote:
      "The Ubisoft creator program has provided me with opportunities to give back to the community alongside working with other Ubisoft Creators allowing me to make new friends and grow my audience.\nUCP  has been a game changer for my streams and my content.",
  },
  {
    name: "@NarcolepticNugget",
    src: NarcolepticNugget,
    link: "https://www.youtube.com/@NarcolepticNugget",
    quote:
      "It's the Easist way to stay in the loop on everything Ubisoft is cooking BTS",
  },
  {
    name: "@TomJSherlock",
    src: TomJSherlock,
    link: "https://www.twitch.tv/tomjsherlock",
    quote:
      "Being part of the Ubisoft Creator Program has been a wonderful and fulling experience, from getting to experience the lastest ubisoft title releases with my community or helping them get the latest bits of free loot thanks to the Drop programme",
  },
  {
    name: "@TitaniumRolo",
    src: TitaniumRolo,
    link: "https://www.tiktok.com/@titaniumrolo",
    quote:
      "The Ubisoft creator programe is great because it helps me plan my content. I always know early when somethings coming so I can plan ahead'",
  },
];
